import { render } from "./AddonAttachments.vue?vue&type=template&id=44b0e8d9&scoped=true"
import script from "./AddonAttachments.vue?vue&type=script&lang=js"
export * from "./AddonAttachments.vue?vue&type=script&lang=js"

import "./AddonAttachments.vue?vue&type=style&index=0&id=44b0e8d9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b0e8d9"]])

export default __exports__